import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router";
import { fetchAdminApi, fetchApi } from '../../../services/api';
import { Button, Card, Divider, Form, message, Space, Spin, Popconfirm } from 'antd';
import constants from '../../../constants/constants';
import RecoveryPlanSummary from './RecoveryPlanSummary';
import { DOB } from '../../../globalFunctions/GlobalFunctions';
import { COOKIE, getCookie } from '../../../services/cookie';
import TextArea from 'antd/es/input/TextArea';
import moment from 'moment';

const DischargePlan = () => {
	const [form] = Form.useForm();
	const history = useHistory();
	const [selectedSummarySections, setSelectedSummarySections] = useState([]);
	const [selectedGoalStatement, setSelectedGoalStatement] = useState({});
	const [selectedAreaComprehensiveEvaluation, setSelectedAreaComprehensiveEvaluation] = useState({});
	const adminClientValue = JSON.parse(sessionStorage.getItem("adminClientValue"));
	const [loader, setLoader] = useState(false);
	const [noteId, setNoteId] = useState(null);
	const [result, setResult] = useState({});
	const current = new Date();
	const [isSigned, setIsSigned] = useState(false);
	const [noteData, setNoteData] = useState(null);
	const isAdmin = getCookie(COOKIE.LoginType) === "0" ? false : true;
	const [date, setDate] = useState({
		date: current.getDate(),
		month: (current.getMonth() + 1).toString().padStart(2, '0'),
		year: current.getFullYear()
	});
	const handleDayChange = (value) => {
		setDate({
			...date,
			date: value
		});
	};
	const handleMonthChange = (value) => {
		setDate({
			...date,
			month: value
		});
	};
	const handleYearChange = (value) => {
		setDate({
			...date,
			year: value
		});
	};
	useEffect(() => {
		getRecoverySummary();
	}, []);

	const getRecoverySummary = () => {
		setLoader(true);
		const clientId = adminClientValue?.clientId || adminClientValue?.client_id;
		const handleResponse = (res) => {
			if (res?.code === 200) {
				setLoader(false);
				setNoteId(res?.data?.notes_id || null);
				setSelectedSummarySections(isAdmin ? (res?.data?.discharge_summary?.selected_summary_sections || []) : res?.data?.answers?.selected_summary_sections);
				setSelectedGoalStatement(isAdmin ? (res?.data?.discharge_summary?.selected_goal_statement || {}) : res?.data?.answers?.selected_goal_statement);
				setSelectedAreaComprehensiveEvaluation(isAdmin ? (res?.data?.discharge_summary?.selected_evaluation || {}) : res?.data?.answers?.selected_evaluation);
				setResult(isAdmin ? (res?.data?.discharge_summary?.result || {}) : res?.data?.answers?.result);
				if (res?.data?.signed_by || !isAdmin) {
					setIsSigned(true); // disable the form if signed
				}
				form.setFieldsValue(
					isAdmin
						? {
							plan: res?.data?.discharge_summary?.plan || null,
							summary: res?.data?.discharge_summary?.summary || null,
						}
						: {
							plan: res?.data?.answers?.plan || null,
							summary: res?.data?.answers?.summary || null,
						}
				);
				if (res?.data?.dt_created) {
					const noteDateObj = new Date(res.data.dt_created);
					setDate({
						date: noteDateObj.getDate().toString().padStart(2, '0'),
						month: (noteDateObj.getMonth() + 1).toString().padStart(2, '0'),
						year: noteDateObj.getFullYear().toString()
					});
				}
				setNoteData(res?.data);
			} else {
				setIsSigned(false);
				setLoader(false);
				setSelectedSummarySections([]);
				setSelectedGoalStatement({});
				setSelectedAreaComprehensiveEvaluation({});
				setResult({});
				setNoteId(null);
				message.error(res?.message);
			}
		};
		if (isAdmin) {
			fetchAdminApi(`/get-dischargeplan-answer`, 'post', { client_id: clientId }).then(handleResponse);
		}
		else {
			fetchApi(`/get-discharge-plan/${clientId}`, 'get').then(handleResponse);
		}
	};

	const onFinishForm = (values, type = null) => {
		setLoader(true);
		let admin_id = getCookie(COOKIE.ClientId);
		let formdata = values;
		formdata.selected_summary_sections = selectedSummarySections;
		formdata.selected_goal_statement = selectedGoalStatement;
		formdata.selected_evaluation = selectedAreaComprehensiveEvaluation;
		formdata.result = result;
		let payload = {
			notes_content: null,
			notes_assesment: null,
			notes_plan: null,
			section_id: null,
			notes_type: "9",
			dt_created: `${date.year}-${date.month}-${date?.date}`,
			answers: formdata,
			admin_id: admin_id,
			client_id: adminClientValue?.clientId
		};
		if (type === "esign") {
			payload.signed_by = admin_id;
			const currentDate = new Date();
			payload.dt_updated = currentDate.toISOString().split("T")[0];
		}
		let method;
		let url;
		if (noteId !== null) {
			payload.notes_id = noteId;
			method = "put";
			url = '/edit-notes';
		} else {
			method = "post";
			url = '/add-notes';
		}
		fetchAdminApi(url, method, payload).then((res) => {
			if (res?.code && res.code === 200) {
				setLoader(false);
				message.success(res?.message);
				history.push("/edit-client");
			} else {
				setLoader(false);
				message.error(res?.message);
			}
		});
	};

	const onChangeAnswer = (value, key) => {
		setResult(prevAnswers => ({
			...prevAnswers,
			[key]: value
		}));
	};

	const handleEsignConfirm = () => {
		form
			.validateFields()
			.then((values) => {
				onFinishForm(values, "esign");
			})
			.catch(() => {
				message.error("Please try again later");
			});
	};

	const handleRedirect = () => {
		if (isAdmin) {
			if (adminClientValue?.clientId) {
				history.push("/view-client");
			} else {
				history.push("/view-enquiry");
			}
		} else {
			history.push("/dashboard");
		}
	};

	const handleBackClick = () => {
		if (history.length > 1) {
			history.goBack();
		} else {
			handleRedirect();
		}
	};

	return (
		<div className='add-note'>
			<div className='text-center bg-amber-300 text-lg font-semibold p-3'>
				{constants.Subtitle}
				<span className="py-0.5 px-3 ml-3 text-sm bg-white rounded-xl">
					{constants.DischargePlan}
				</span>
			</div>
			<div className='bg-amber-100 text-base font-semibold p-2 mb-3'>
				<div className='container mx-auto'>
					<Space size={'small'} wrap direction="vertical">
						<span>{constants.DischargePlan} : {adminClientValue?.client_name}{adminClientValue?.client_serial_number ? `(# ${adminClientValue?.client_serial_number})` : null}</span>
						<Button size='small' className='text-xs font-semibold bg-sky-800 text-white uppercase' onClick={handleBackClick}>{constants.BackBtn}</Button>
					</Space>
				</div>
			</div>
			<div className='container mx-auto'>
				{DOB(date.month, handleMonthChange, date.date, handleDayChange, date.year, handleYearChange, "Date", isSigned)}
				<Spin spinning={loader} size="large">
					<Card
					>
						<Form layout='vertical' className='mb-10 text-black client-details' onFinish={onFinishForm} form={form}>
							<RecoveryPlanSummary
								selectedSummarySections={selectedSummarySections}
								selectedGoalStatement={selectedGoalStatement}
								selectedAreaComprehensiveEvaluation={selectedAreaComprehensiveEvaluation}
								options={constants.ComprehensivePsychosocialOptions}
								showTextArea={true}
								onChangeAnswer={onChangeAnswer}
								result={result}
								esign={isSigned}
							/>
							<Divider className='my-7 border-gray-800' />
							<div className="flex gap-2 mt-2">
								<span className="text-sm font-semibold min-w-[60px]">Summary</span>
								<div className="flex-1">
									<Form.Item name={"summary"}>
										<TextArea rows={4} disabled={isSigned} />
									</Form.Item>
								</div>
							</div>
							<div className="flex gap-2 mt-2">
								<span className="text-sm font-semibold min-w-[60px]">Plan</span>
								<div className="flex-1">
									<Form.Item name={"plan"}>
										<TextArea rows={4} disabled={isSigned} />
									</Form.Item>
								</div>
							</div>
							<Form.Item>
								<Space className="float-left">
									<Button className='bg-sky-800 text-white uppercase' type='primary' onClick={handleRedirect}>
										{constants.Cancel}
									</Button>
									{
										isAdmin && <><Button className='bg-sky-800 text-white uppercase' type='primary' htmlType="submit" disabled={isSigned}>
											{constants.Save}
										</Button>
											<Popconfirm title="You will not be able to Edit after you Esign the Notes" onConfirm={handleEsignConfirm}>
												<Button className='bg-sky-800 text-white uppercase' disabled={isSigned}>{constants.Esign}</Button>
											</Popconfirm></>
									}
									{
										isSigned ?
											<span className='text-sm italic'>E-signed by {noteData?.signed_by_name} on {moment(noteData?.signed_on).format(constants.dateformat)}</span> :
											<span></span>
									}
								</Space>
							</Form.Item>
						</Form>
					</Card>
				</Spin>
			</div>
		</div>
	)
}

export default DischargePlan
